// extracted by mini-css-extract-plugin
export default {"arrow-button":"DpBT9","page-button":"Tuusy","page-button-active":"C5XlL","dots-icon":"_lekK"};